import React, { Component } from 'react';
import { Show, List, TabbedShowLayout, Tab, Datagrid, BooleanField, EditButton, TextField, ReferenceField, ReferenceManyField, DateField, TopToolbar, RefreshButton, ListButton, ExportButton } from 'react-admin';
import { CamelCaseField, ExpectedDateField } from '../digitalOrders/common';
import { Scrollbars } from 'react-custom-scrollbars';
import { getLocalStorageKey, CommonHeaderOption, RUN_TIME_API_ENDPOINT } from '../common/common';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

class ShowActions extends Component {
    callExport = (e, data) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        options.method = 'GET';
        fetch(`${apiUrl}/${this.props.resource}_for_sdo_csv/${data.id}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('json= inside callback', jsonD.data);
                const msg = jsonD.data ? jsonD.data[0].message : '';
                Swal.fire({
                    html: msg,
                    icon: 'success',
                })
            });
    }

    render() {
        const { data, resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters, basePath } = this.props;
        const csvResource = 'empty_data';
        return (
            <React.Fragment>
                <TopToolbar>
                    <RefreshButton />
                    <ListButton basePath={basePath} />
                    {/* <ExportButton
                        onClick={e => this.callExport(e, data)}
                        disabled={total === 0}
                        sort={data && data.created_at}
                        resource={csvResource}
                    /> */}
                    <div>
                        <button className="export-button"
                            onClick={(e) => this.callExport(e, data)}
                            disabled={total === 0}
                            sort={data && data.created_at}
                        >
                            {<GetAppIcon />}
                            <span>Export</span>
                        </button>
                    </div>
                </TopToolbar>
            </React.Fragment>
        )
    }
}

const ShowTitle = ({ record }) => {
    return record && <span>Notification {record.name}</span>;
};

class SoAppNotificationShow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingShow: false
        }
    }

    render() {
        const { props, permissions, state } = this;
        console.log('xxxx', state.soldToList, props.id);
        return (
            <Show actions={<ShowActions permissions={permissions} />} {...props} title={<ShowTitle />}>
                <TabbedShowLayout className="tab-scroll">
                    <Tab label="Details" contentClassName="scrollTab">
                        <TextField label="Purpose" source="purpose" allowEmpty />
                        <TextField label="Title" source="title" allowEmpty />
                        <TextField label="Description" source="description" allowEmpty />
                        <TextField label="Type" source="type" sortable={false} allowEmpty />
                        <TextField label="Notification Progress" source="job_status" />
                        <TextField label="Creator Name" source="admin_name" />
                        <TextField label="Creator Email" source="admin_email" />
                        <TextField label="Count of targeted sales officers" source="targeted_sales_officers_count" allowEmpty />
                        <TextField label="Count of sales officers notified" source="notified_sales_officers_count" allowEmpty />
                        <TextField label="Count of sales officers who have read" source="notification_read_count" allowEmpty />
                        <TextField label="Completion %" source="send_status_percent" allowEmpty />
                        {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                        <DateField 
                        // label="Created At" 
                        source="created_at" showTime />
                    </Tab>
                    <Tab label="Sales Officers List">
                        <ReferenceManyField
                            addLabel={false}
                            reference="so_in_app_sold_to_list"
                            target="id"
                            className="tab-pagination"
                        >
                            <List {...props}
                                filterDefaultValues={{ id: props.id }}
                                bulkActionButtons={false} exporter={false}>
                                <Datagrid className="tab-data-grid">
                                    <TextField label="Name" source="name" />
                                    <BooleanField label="Notification Status" sortable={false} source="notification_status" />
                                    <BooleanField label="Read Status" source="read_status" />
                                    <DateField label="Notification Sent At" source="notification_sent_at" />
                                </Datagrid>
                            </List>
                        </ReferenceManyField>
                    </Tab>
                </TabbedShowLayout>
            </Show>
        );
    };
}

export default SoAppNotificationShow;